module.exports = __webpack_public_path__ + "5b00a03f410139a57a29ce558506676e.svg";